import { ArrowRight, CheckCircle, Star } from 'lucide-react';

const BrokeragePlans = () => {
  const plans = [
    {
      name: 'Trade Premier Plus',
      tag: 'Most Popular',
      link: 'https://angel-one.onelink.me/Wjgr/j7wbqid5',
      highlight: true,
      features: [
        { label: 'Equity Delivery', value: 'INR 20 or 0.1% whichever is lower per executed order', note: 'Minimum brokerage of INR 5 will be levied' },
        { label: 'Intra-day', value: 'INR 20 or 0.1% whichever is lower per executed order', note: null },
        { label: 'Futures & Options', value: 'INR 20 per executed order', note: null },
        { label: 'Commodity', value: 'INR 20 per executed order', note: null },
        { label: 'Currency', value: 'INR 20 per executed order', note: null },
      ],
    },
    {
      name: 'iTrade Premier Pro Plus',
      tag: 'Free Advisory Included',
      link: 'https://angel-one.onelink.me/Wjgr/qcaihuuv',
      highlight: false,
      features: [
        { label: 'Equity Delivery', value: 'INR 300 or 0.3% whichever is lower per executed order', note: 'Minimum brokerage of INR 5 will be levied' },
        { label: 'Intra-day', value: 'INR 30 or 0.1% whichever is lower per executed order', note: 'Minimum brokerage of INR 5 will be levied' },
        { label: 'Futures & Options', value: 'INR 30 per executed order', note: null },
        { label: 'Commodity', value: 'INR 30 per executed order', note: null },
        { label: 'Currency', value: 'INR 30 per executed order', note: null },
      ],
    },
  ];

  return (
    <div>
      <section className="py-24 md:py-32" style={{ backgroundColor: '#FAFAFA' }}>
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
          <div className="max-w-3xl mx-auto text-center mb-16">
            <h1
              className="text-4xl sm:text-5xl lg:text-6xl tracking-tighter font-bold mb-6"
              style={{ fontFamily: 'Outfit', color: '#0A0F1A' }}
              data-testid="plans-heading"
            >
              Brokerage Plans
            </h1>
            <p className="text-base leading-relaxed" style={{ color: '#475569' }}>
              Choose the plan that best suits your trading style. Both plans include free Demat account opening with Angel One.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
            {plans.map((plan, idx) => (
              <div
                key={idx}
                data-testid={`plan-card-${idx}`}
                className="relative bg-white border-2 overflow-hidden"
                style={{
                  borderColor: plan.highlight ? '#FF5722' : 'rgba(10,15,26,0.05)',
                }}
              >
                {plan.tag && (
                  <div
                    className="text-center py-2 text-sm font-semibold"
                    style={{
                      backgroundColor: plan.highlight ? '#FF5722' : '#0A0F1A',
                      color: 'white',
                    }}
                    data-testid={`plan-tag-${idx}`}
                  >
                    <div className="flex items-center justify-center gap-2">
                      <Star size={14} fill="white" />
                      {plan.tag}
                    </div>
                  </div>
                )}

                <div className="p-8">
                  <h2
                    className="text-2xl sm:text-3xl font-bold mb-6"
                    style={{ fontFamily: 'Outfit', color: '#0A0F1A' }}
                  >
                    {plan.name}
                  </h2>

                  <div className="space-y-4 mb-8">
                    {plan.features.map((feature, fidx) => (
                      <div
                        key={fidx}
                        className="pb-4"
                        style={{ borderBottom: '1px solid #E2E8F0' }}
                        data-testid={`plan-${idx}-feature-${fidx}`}
                      >
                        <div className="flex items-start gap-3">
                          <CheckCircle size={18} style={{ color: '#10B981', flexShrink: 0, marginTop: '3px' }} />
                          <div>
                            <p className="font-semibold text-sm mb-1" style={{ color: '#0A0F1A' }}>
                              {feature.label}
                            </p>
                            <p className="text-sm" style={{ color: '#475569' }}>
                              {feature.value}
                            </p>
                            {feature.note && (
                              <p className="text-xs mt-1" style={{ color: '#94A3B8' }}>
                                ({feature.note})
                              </p>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>

                  <a
                    href={plan.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`plan-cta-${idx}`}
                    className="w-full flex items-center justify-center gap-2 py-4 font-semibold text-base transition-all"
                    style={{
                      backgroundColor: plan.highlight ? '#FF5722' : '#0A0F1A',
                      color: 'white',
                      textDecoration: 'none',
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-2px)';
                      e.currentTarget.style.boxShadow = plan.highlight
                        ? '0 8px 24px rgba(255,87,34,0.3)'
                        : '0 8px 24px rgba(10,15,26,0.2)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = 'none';
                    }}
                  >
                    Open Account with This Plan
                    <ArrowRight size={18} />
                  </a>
                </div>
              </div>
            ))}
          </div>

          <div className="max-w-5xl mx-auto mt-12">
            <div className="p-6 bg-white border border-[rgba(10,15,26,0.05)]">
              <h3
                className="text-xl font-semibold mb-4"
                style={{ fontFamily: 'Outfit', color: '#0A0F1A' }}
              >
                Which Plan Should You Choose?
              </h3>
              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <p className="font-semibold text-sm mb-2" style={{ color: '#FF5722' }}>
                    Trade Premier Plus
                  </p>
                  <p className="text-sm" style={{ color: '#475569' }}>
                    Best for active traders who want the lowest brokerage charges. Flat INR 20 per order across all segments makes it ideal for frequent trading.
                  </p>
                </div>
                <div>
                  <p className="font-semibold text-sm mb-2" style={{ color: '#0A0F1A' }}>
                    iTrade Premier Pro Plus
                  </p>
                  <p className="text-sm" style={{ color: '#475569' }}>
                    Best for investors who want expert guidance. This plan includes free advisory from Angel One's research team along with your trading account.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="text-center mt-8">
            <p className="text-sm" style={{ color: '#94A3B8' }}>
              Need help choosing? Contact us on WhatsApp at +91 99023 00787
            </p>
          </div>
        </div>
      </section>

      <section className="py-16" style={{ backgroundColor: '#FAFAFA' }}>
        <div className="max-w-5xl mx-auto px-6 md:px-12 lg:px-24">
          <p className="text-xs text-center" style={{ color: '#94A3B8' }}>
            *All charges are exclusive of applicable taxes (GST, STT, etc.). Brokerage plans are subject to change as per Angel One's policies. Stock market investments are subject to market risks. Read all related documents carefully before investing.
          </p>
        </div>
      </section>
    </div>
  );
};

export default BrokeragePlans;
